import React, { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { connect } from 'react-redux'
import { useScreenshot, createFileName } from 'use-react-screenshot'

import './OrderBook.scss'
import SideDrawer from '../Common/SideDrawer/SideDrawer'
import LocationIcon from '../../assets/LocationIcon'
import DownloadIcon from '../../assets/DownloadIcon'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import {
    convertToTitleCase,
    formatDate,
    formatTime
} from '../../common/utils/appUtils'
import Config from '../../config/config'

function ViewOrderBook({
    open,
    handleDrawerToggle,
    data,
    onConfirmClick,
    onConfirmOrder,
    onCancelOrder,
    drawerButton,
    isDrawerButtonVisible
}) {
    const navigate = useNavigate()
    const ref = useRef(null)
    const [image, takeScreenshot] = useScreenshot()
    
    // Get status in uppercase for comparison
    const status = data?.status?.toUpperCase()
    const isHold = status === 'HOLD' || status === 'PENDING'
    const isConfirmed = status === 'CONFIRMED' || status === 'COMPLETED'
    const isReceived = status === 'RECEIVED'

    // useEffect(() => {
    //     if (image) {
    //         download(image, { name: 'order-book', extension: 'png' })
    //     }
    // }, [image])

    // const getImage = () => {
    //     console.log('get image clicked')
    //     takeScreenshot(ref.current, { padding: 20 })
    // }

    // const download = (iImage, { name = 'img', extension = 'png' } = {}) => {
    //     const a = document.createElement('a')
    //     a.href = iImage
    //     a.download = createFileName(extension, name)
    //     a.click()
    // }

    // const captureScreenshot = () => {
    //     var canvasPromise = html2canvas(ref.current, {
    //         useCORS: true
    //     })

    //     canvasPromise.then(canvas => {
    //         var dataURL = canvas.toDataURL('order-book/png')
    //         // Create an image element from the data URL
    //         var img = new Image()
    //         img.src = dataURL
    //         // img.alt = 'order'
    //         img.download = 'order-book.png'
    //         // Create a link element
    //         var a = document.createElement('a')
    //         a.innerHTML = 'DOWNLOAD'
    //         a.target = '_blank'
    //         // Set the href of the link to the data URL of the image
    //         a.href = img.src
    //         // Set the download attribute of the link
    //         a.download = img.download
    //         // Append the link to the page
    //         document.body.appendChild(a)
    //         // Click the link to trigger the download
    //         a.click()
    //     })
    // }

    const captureScreenshot = () => {
        try {
            var canvasPromise = html2canvas(ref.current, {
                useCORS: true,
                allowTaint: true,
                letterRendering: true,
                scale: window.devicePixelRatio * 3,
                logging: true
            })

            canvasPromise.then(canvas => {
                var paddedCanvas = document.createElement('canvas')
                var context = paddedCanvas.getContext('2d')
                var padding = 30
                paddedCanvas.width = canvas.width + 2 * padding
                paddedCanvas.height = canvas.height + 2 * padding
                context.fillStyle = '#ffffff' // background color
                context.fillRect(0, 0, paddedCanvas.width, paddedCanvas.height)
                context.drawImage(canvas, padding, padding)

                // Convert the modified canvas to a data URL
                var dataURL = paddedCanvas.toDataURL('image/png')

                const pdf = new jsPDF('p', 'mm', 'a4') // 'p' for portrait, 'a4' paper size

                // Set the width and height for the image
                const pdfWidth = pdf.internal.pageSize.getWidth()
                const pdfHeight = (canvas.height * pdfWidth) / canvas.width

                // Add the image to the PDF
                pdf.addImage(dataURL, 'PNG', 0, 0, pdfWidth, pdfHeight)
                pdf.save('order-book.pdf')

                // var a = document.createElement('a')
                // a.innerHTML = 'DOWNLOAD'
                // a.target = '_blank'
                // a.href = dataURL
                // // Set the download attribute of the link
                // a.download = 'order-book.png' // filename
                // document.body.appendChild(a)

                // a.click()
                // document.body.removeChild(a)
            })
        } catch (errMsg) {
            console.log('errMsg: ', errMsg)
        }
    }

    // Get button text based on status
    const getButtonText = () => {
        if (isHold) return 'Confirm Order'
        if (isConfirmed) return 'Receive Products'
        return ''
    }

    // Get button click handler based on status
    const getButtonHandler = () => {
        if (isHold) return onConfirmOrder
        if (isConfirmed) return onConfirmClick
        return null
    }

    // Show drawer button for Hold and Confirmed status
    const showDrawerButton = drawerButton && (isHold || isConfirmed)

    return (
        <div>
            <SideDrawer
                handleDrawerToggle={handleDrawerToggle}
                open={open}
                drawerButton={showDrawerButton}
                buttonText={getButtonText()}
                handleClick={getButtonHandler()}
                // viewScreenButton={true}
            >
                <div className="viewProductWrap viewOrderBook">
                    <div ref={ref}>
                        <div className="viewProductHeader">
                            <div className="headerRowLeft">
                                {`${formatDate(
                                    data?.created_at
                                )} | ${formatTime(data?.created_at)}`}
                                {/* 28 Dec 2023 | 12:30 pm */}
                            </div>
                            <div className="ProductUniqueTag">
                                {data?.order_no}
                            </div>
                        </div>
                        <div className="viewProductHeader">
                            <div className="contactDetailsRow dFlex aiCenter">
                                <div className="contactDetailsRowLogo">
                                    {data?.branch?.logo ? (
                                        <img
                                            src={Config.getFullImageUrl(data?.branch?.logo)}
                                            alt={data?.branch?.display_name || 'Pharmacy'}
                                            onError={(e) => {
                                                e.target.style.display = 'none'
                                                e.target.parentNode.innerHTML = `<div class="logoPlaceholder">${(data?.branch?.pharmacy_name || data?.branch?.name || 'P').charAt(0)}</div>`
                                            }}
                                        />
                                    ) : (
                                        <div className="logoPlaceholder">
                                            {(data?.branch?.pharmacy_name || data?.branch?.name || 'P').charAt(0)}
                                        </div>
                                    )}
                                </div>
                                <div className="moreDetailsRow">
                                    <ul className="moreDetailsRow dFlex">
                                        <li className="moreDetails strong">
                                            {data?.branch?.display_name || `${data?.branch?.pharmacy_name} (${data?.branch?.name})`}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="productSupplierAddress dFlex">
                                <LocationIcon className="icon" />
                                {data?.branch?.location}
                            </div>
                        </div>
                        <div className="viewProductHeader">
                            <div className="headerRowLeft">Pharma Company</div>
                            <div className="ProductUniqueTag">
                                {data?.pharma?.name}
                            </div>
                        </div>
                        <div className="mb-5">
                            <table className="orderBook viewOrderBookTable">
                                <thead>
                                    <tr>
                                        <td width="5%">S/N</td>
                                        <td>Product Details</td>
                                        <td>Category</td>
                                        <td className="alignright">Pack Size</td>
                                        <td className="alignright">Order Pack</td>
                                        <td className="alignright">Qty</td>
                                        <td width="18%" className="alignright">Amount</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data?.product_details?.map((product, index) => {
                                        // Format product details: "Product name (size)-Strength"
                                        const productData = product.product || {}
                                        const name = productData.name || ''
                                        const size = productData.size || ''
                                        const strength = productData.dose || productData.strength || ''
                                        const formattedName = size 
                                            ? `${name} (${size})-${strength}`
                                            : (strength ? `${name}-${strength}` : name)

                                        return (
                                            <tr key={product.id || index}>
                                                <td>{index + 1}</td>
                                                <td>{formattedName}</td>
                                                <td>{productData.category || '-'}</td>
                                                <td className="alignright">{productData.pack_size || '-'}</td>
                                                <td className="alignright">{product?.order_pack || '-'}</td>
                                                <td className="alignright">{product?.quantity}</td>
                                                <td className="nowrap alignright">
                                                    {`BDT ${product?.amount || '-'}`}
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colSpan={5}>Total</td>
                                        <td className="alignright strong">
                                            {data?.total_quantity || 0}
                                        </td>
                                        <td className="alignright strong">
                                            {`BDT ${data?.total_amount || '-'}`}
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                    <div className="actionButton mt-5 dFlex aiCenter" style={{ justifyContent: 'flex-end' }}>
                        {/* Download button for all statuses */}
                        <button
                            className="btn btnPrimary dFlex"
                            onClick={() => captureScreenshot()}>
                            <DownloadIcon />
                        </button>
                    </div>
                </div>
            </SideDrawer>
        </div>
    )
}

const mapStateToProps = state => {
    return {}
}
const mapDispatchToProps = dispatch => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewOrderBook)
